import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { api, resolveImg, money } from '@/lib/api';
import { useCart } from '@/context/CartContext';

export default function Sets() {
  const [bundles, setBundles] = useState([]);
  const { add } = useCart();

  useEffect(() => { api.get('/bundles').then(({ data }) => setBundles(data)); }, []);

  const addSet = (b) => {
    add({ id: `bundle_${b.id}`, bundle_id: b.id, name: b.name, price: b.price, images: [b.image], is_presale: false, category: null });
  };

  return (
    <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 lg:py-24">
      <p className="eyebrow mb-3">Curated pairings</p>
      <h1 className="font-serif text-4xl lg:text-6xl mb-4">Matching Sets</h1>
      <p className="text-muted-foreground max-w-xl mb-12">Earring-and-ring pairings, offered together at a special price.</p>

      {bundles.length === 0 ? (
        <p className="text-muted-foreground">No sets available yet.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="sets-grid">
          {bundles.map((b, i) => (
            <motion.div key={b.id} data-testid={`bundle-${b.id}`}
              initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.08 }}
              className="border border-border bg-surface overflow-hidden">
              <div className="grid grid-cols-2">
                {b.products.map((p) => (
                  <div key={p.id} className="aspect-square bg-surface-elevated overflow-hidden">
                    <img src={resolveImg(p.image)} alt={p.name} className="w-full h-full object-cover" />
                  </div>
                ))}
              </div>
              <div className="p-6">
                <h3 className="font-serif text-2xl mb-1">{b.name}</h3>
                <p className="text-sm text-muted-foreground mb-4">{b.description}</p>
                <p className="text-xs text-muted-foreground mb-4">{b.products.map((p) => p.name).join(' + ')}</p>
                <div className="flex items-center gap-3 mb-5">
                  <span className="font-mono text-xl text-gold">{money(b.price)}</span>
                  {b.original_price > b.price && <span className="font-mono text-sm text-muted-foreground line-through">{money(b.original_price)}</span>}
                  {b.original_price > b.price && <span className="text-[10px] font-mono uppercase px-2 py-0.5 bg-gold/15 text-gold">Save {money(b.original_price - b.price)}</span>}
                </div>
                <button data-testid={`add-set-${b.id}`} onClick={() => addSet(b)}
                  className="w-full bg-gold text-primary-foreground py-3.5 text-xs font-mono uppercase tracking-widest hover:bg-gold-hover transition-colors">
                  Add Set to Bag
                </button>
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
